'use strict';

var _ = require('lodash');

var $form, $continue, $requiredInputs, validator, $cardList, requiredValues;

var hasEmptyRequired = function () {

    if ($cardList.length > 0 && $('#is-CREDIT_CARD').is(':checked') || $cardList.length === 0 && $('#is-CREDIT_CARD').is(':checked') && $('[id$="billing_addressList"]').is(':visible')) {
        var $addressFormValues = $('.required', '.js-address').find(':input:not(.selectric-input)');
        var $cardValues = $('.required', '.order--checkout__ccnew').find(':input:not(.selectric-input)');
        var $savedCardCVN = $(':input:not(.selectric-input).required', '.cvv-wrapper');
        $requiredInputs = $.merge($addressFormValues, $.merge($cardValues, $savedCardCVN));

        requiredValues = $requiredInputs.map(function () {
            return $(this).val();
        });
    } else {
        requiredValues = $requiredInputs.filter(':visible').map(function () {
            return $(this).val();
        });
    }
    return _(requiredValues).includes('');
};


var validateForm = function () {
    // only validate form when all required fields are filled to avoid
    // throwing errors on empty form
    if (!validator) {
        return;
    }
    if (!hasEmptyRequired()) {
        if (validator.form()) {
            var radiobuttons = $('input[name$="_addressList"]'),
                isAddressInactive = $('input[name$="Address"]').hasClass('toggle--active'),
                isChecked = false,
                isVisible = $('.order--checkout--limit').is(':visible') || ($('.address-preview').length > 0 && !$('.address-preview').hasClass('hidden')) || $('#shippingBillingSame').length > 0 && $('#shippingBillingSame').val()=='on';

            if (radiobuttons.length && !isAddressInactive && !isVisible) {
                for (var i = 0; i < radiobuttons.length; i++) {
                    if (radiobuttons[i].type === 'radio' && radiobuttons[i].checked) {
                        isChecked = true;
                    } else {
                        $continue.prop('disabled', true);
                    }
                } if (isChecked) {
                    $continue.prop('disabled', false).trigger('enabled');
                }
            } else {
                $continue.prop('disabled', false).trigger('enabled');
            }
        }
    } else {
        // $continue.attr('disabled', 'disabled');
        $continue.prop('disabled', true);
    }
};

var validateEl = function () {
    if ($(this).val() === '') {
        // $continue.attr('disabled', 'disabled');
        $continue.prop('disabled', true);
    } else {
        var notIgnored = $(this).not(validator.settings.ignore)[0];
        if (!hasEmptyRequired() && (!notIgnored || validator.valid(this))) {
            // $continue.removeAttr('disabled');
            $continue.prop('disabled', false).trigger('enabled');
        } else {
            // $continue.attr('disabled', 'disabled');
            $continue.prop('disabled', true);
        }
    }
};

var init = function (opts) {
    if (!opts.formSelector || !opts.continueSelector) {
        throw new Error('Missing form and continue action selectors.');
    }
    $form = $(opts.formSelector);
    $continue = $(opts.continueSelector);

    validator = $form.validate();
    $cardList = $form.find('[id$="ckoCreditCardList"]');
    $requiredInputs = $('.required', $form).find(':input:not(.selectric-input)');
    validateForm();
    // start listening
    $requiredInputs.on('change', validateEl);
    $requiredInputs.filter('input')
        .on('keyup', _.debounce(validateEl, 200))
        .on('change', function () {
            validateEl();
            $(this).valid();
        })
};

exports.init = init;
exports.validateForm = validateForm;
exports.validateEl = validateEl;



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/pages/checkout/formPrepare.js